import React from 'react';

const ThemeToggle = ({ currentTheme, onThemeChange }) => {
  const themes = [
    { id: 'default', label: 'Default' },
    { id: 'retro', label: 'Retro' },
    { id: 'cyberpunk', label: 'Cyberpunk' },
    { id: 'synthwave', label: 'Synthwave' },
    { id: 'aurora', label: 'Aurora' },
  ];

  return (
    <label className="themeSelect">
      <span>Theme</span>
      <select value={currentTheme} onChange={(e) => onThemeChange(e.target.value)}>
        {themes.map((theme) => (
          <option key={theme.id} value={theme.id}>{theme.label}</option>
        ))}
      </select>
    </label>
  );
};

export default ThemeToggle;
